import { query } from '@confluence/query-preloader-tools';

import { EditorContentStateQuery } from './EditorContentStateQuery.graphql';
import type {
	EditorContentStateQuery as EditorContentStateQueryType,
	EditorContentStateQueryVariables,
} from './__types__/EditorContentStateQuery';

type PreloadEditorContentStateParams = {
	contentId: any;
	useCache: boolean;
	shouldGetDraftVersion: boolean;
};

export function preloadEditorContentState({
	contentId,
	useCache,
	shouldGetDraftVersion,
}: PreloadEditorContentStateParams) {
	return query<EditorContentStateQueryType, EditorContentStateQueryVariables>({
		query: EditorContentStateQuery,
		variables: {
			contentId,
			isDraft: shouldGetDraftVersion,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
